/**
 * Portal auth signals for coarse notice targeting (sessionStorage — same source as Home).
 */

export function isPortalAuthenticated() {
	try {
		const raw = sessionStorage.getItem("user");
		return !!(raw && raw !== "null" && raw !== "undefined");
	} catch (e) {
		return false;
	}
}

/**
 * Best-effort role strings for audience.roles matching (Cognito groups + common fallbacks).
 * @returns {string[]}
 */
export function getPortalUserRoles() {
	const roles = new Set();
	try {
		const raw = sessionStorage.getItem("user");
		if (!raw) return [];
		const user = JSON.parse(raw);
		const payload =
			user &&
			user.signInUserSession &&
			user.signInUserSession.idToken &&
			user.signInUserSession.idToken.payload;
		const groups = payload && payload["cognito:groups"];
		if (Array.isArray(groups)) {
			groups.forEach(function (g) {
				roles.add(String(g));
			});
		}
		if (user && Array.isArray(user.roles)) {
			user.roles.forEach(function (r) {
				if (typeof r === "string") roles.add(r);
				else if (r && typeof r === "object") {
					if (r.name) roles.add(String(r.name));
					if (r.id != null) roles.add(String(r.id));
				}
			});
		}
	} catch (e) {
		/* ignore */
	}
	return Array.from(roles);
}

/** Parent account id for M3 account targeting (set on login in App.js). */
export function getPortalAccountId() {
	try {
		const raw = sessionStorage.getItem("parentAccountId");
		if (!raw || raw === "null" || raw === "undefined") return "";
		return String(raw).trim();
	} catch (e) {
		return "";
	}
}



// WEBPACK FOOTER //
// ./src/system-notices/authContext.js